export const ERROR_CODES = {
  BAD_REQUEST: 400,
  CONFLICT: 409,
  NOT_FOUND: 404,
  PRECONDITION_FAILED: 412
};
export const ERROR_TYPES = {
  ARTICLE_ALREADY_EXISTS: 'PAGE_EXISTS',
  ARTICLE_OPTIMISTIC_LOCKING_HANDLED_TYPES: ['ANOTHER_USER', 'SAME_USER_DIFFERENT_SESSION'],
  HOMEPAGE_CATEGORY_CONFLICT_ERROR_TYPES: ['ARTICLE_DOES_NOT_EXIST', 'ARTICLE_NOT_IN_THIS_CATEGORY', 'CATEGORY_DOES_NOT_EXIST'],
  SLUG_CONFLICT_ERROR_TYPES: ['BLOG_EXISTS', 'PAGE_EXISTS', 'SLUG_EXISTS', 'REDIRECT_EXISTS', 'CATEGORY_NOT_FOUND', 'INVALID_AUDIENCE_ACCESS', 'LANGUAGE_UNSUPPORTED'],
  CREATE_ARTICLE_ERROR_TYPES: ['OBJECT_LIMIT_REACHED_FOR_PORTAL'],
  CREATE_LANGUAGE_VARIANT_ERROR_TYPES: ['OBJECT_LIMIT_REACHED_FOR_PORTAL'],
  CREATE_CATEGORY_ERROR_TYPES: ['RESERVED_NAMESPACE', 'OBJECT_ALREADY_EXISTS'],
  NONEMPTY_CATEGORY: 'NONEMPTY_CATEGORY'
};